import axios from "../axios";
import * as fetchResponseHandling from "./../responseHandling/fetch"
import * as updateResponseHandling from "./../responseHandling/update"
import * as deleteResponseHandling from "./../responseHandling/delete"

// This also ends up being fetchLesson() since this also returns a lesson
async function fetchLessonModules(lessonId) {
  // This API call returns both the lesson and the lesson's lesson modules
  const res = await axios.get(`/teachers/lesson_modules/${lessonId}`);
  if (res.status === 200) {
    res.data.lesson_modules.sort((a, b) => a.position - b.position);
    return res.data;
  }
  return fetchResponseHandling.parseResponse(res);
}

async function updateLessonModules(lessonId, body = []) {
  const res = await axios.put(`/teachers/lesson_modules/${lessonId}`, body);
  return updateResponseHandling.parseResponse(res);
}

async function deleteLessonModule(body) {
  const res = await axios.delete(`/teachers/lesson_modules`, {
    data: {
      ...body
    }
  });
  return deleteResponseHandling.parseResponse(res);
}

export {
  fetchLessonModules,
  updateLessonModules,
  deleteLessonModule
}
